export default import.meta.ROLLDOWN_FILE_URL_n504LZfIALgId5kLkDy7gA